<div class="timeline-slider" #element>
  <ng-content></ng-content>
</div>



// WEBPACK FOOTER //
// ./src/app/rec/timeline/timeline-slider/timeline-slider.component.html